import { TFunction } from 'react-i18next'

export const PUBLIC_ROUTES = (
  t: TFunction<'translation'>,
  isAuthenticated: boolean
): Array<{ title: string; path: string }> => {
  return [
    { title: t('top_nav_home_link'), path: isAuthenticated ? '/auth' : '/' },
    {
      title: t('top_nav_about_us_link'),
      path: isAuthenticated ? '/auth/about-us' : '/about-us'
    }
  ]
}
export const PRIVATE_ROUTES = []
